module.exports = function () {
    $(document).ready(function (event) {
        if ($('.gender-selected').val() != 6) {
            $(':input[name=gender_freetext]').hide();
        } else {
            $(':input[name=gender_freetext]').show();
        }

        $('.gender-selected').change(function () {
            if ($('.gender-selected').val() == 6) {
                $(':input[name=gender_freetext]').show().val('').focus();
            } else {
                $(':input[name=gender_freetext]').hide();
            }
        })
    });
}();
